module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_header_2_m-179eee8b130ca5ce70548398e66bfb10.webp";